export const SearchDriverPayload = (props, vehicleType)=>{
    return `from_place_lat=${props?.pickup?.from_place_lat}&from_place_lng=${props?.pickup?.from_place_lng}&to_place_lat=${props?.destination?.to_place_lat}&to_place_lng=${props?.destination?.to_place_lng}&pickup_date_time=${props?.pickupdate_time}&from_place=${props?.pickup?.from_place}&to_place=${props?.destination?.to_place}&distance=&vehicle_type_id=${vehicleType}&page=1&lang=${props?.language?.toLowerCase()}`
}
export const SearchNewDriverPayload = (props, vehicleType, page)=>{
    // return `address_lat=${props?.pickup?.from_place_lat}&address_lng=${props?.pickup?.from_place_lng}&vehicle_type_id=${vehicleType}&page=${page}&lang=${props?.language?.toLowerCase()}&kilometer=${props?.destination?.kilometer}&pickup_date_time=${props?.pickupdate_time}`
    return {
        address_lat:props?.pickup?.from_place_lat,
        address_lng:props?.pickup?.from_place_lng,
        vehicle_type_id:vehicleType,
        page:page,
        lang:props?.language?.toLowerCase(),
        kilometer:props?.destination?.kilometer,
        pickup_date_time:props?.pickupdate_time
    }
}